export default {
    close: 'Close'
}
